import { render } from "./PortofolioK.vue?vue&type=template&id=a3f68394&scoped=true"
import script from "./PortofolioK.vue?vue&type=script&lang=js"
export * from "./PortofolioK.vue?vue&type=script&lang=js"

import "./PortofolioK.vue?vue&type=style&index=0&id=a3f68394&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f68394"]])

export default __exports__